import { Link } from 'react-router-dom'
import './HomeServices.css'
import homeServiceMilkImage from '../../../assets/images/homeServiceMilkImage.webp'
import homeServiceButterImage from '../../../assets/images/homeServiceButterImage.webp'
import homeServiceFermentedMilkImage from '../../../assets/images/homeServiceFermentedMilkImage.webp'
import homeServiceCraftImage from '../../../assets/images/homeServiceCraftImage.webp'

const HomeServices = () => {
  return (
    <section className='home__services-section'>
        <h2 className="home__services-title mont-m">Наша продукція</h2>
        <div className="home__services-wrapper">
            <Link className='home__services-card' to={"/milk/"}>
            <div className="home__services-card-image-wrapper">
                <img src={homeServiceMilkImage} alt="Молоко Pastoral" className="home__services-card-image" />
            </div>
            <p className="home__services-card-name mont-m">Молоко</p>
            </Link>
            <Link className='home__services-card' to={"/butter/"}>
            <div className="home__services-card-image-wrapper">
                <img src={homeServiceButterImage} alt="Масло Pastoral" className="home__services-card-image" />
            </div>
            <p className="home__services-card-name mont-m">Масло</p>
            </Link>
            <Link className='home__services-card' to={"/fermented-milk-products/"}>
            <div className="home__services-card-image-wrapper">
                <img src={homeServiceFermentedMilkImage} alt="Кисломолочні продукти Pastoral" className="home__services-card-image" />
            </div>
            <p className="home__services-card-name mont-m">Кисломолочні продукти</p>
            </Link>
            <Link className='home__services-card' to={"/craft-products/"}>
            <div className="home__services-card-image-wrapper">
                <img src={homeServiceCraftImage} alt="Крафтові продукти Pastoral" className="home__services-card-image" />
            </div>
            <p className="home__services-card-name mont-m">Крафтові продукти</p>
            </Link>
        </div>
    </section>
  )
}

export default HomeServices